import { computed } from "vue";
import {
  getProductDescription,
  getProductImage,
  getProductLink,
  getProductTags
} from "./productContent";
function useProductContent(product) {
  const description = computed(() => getProductDescription(product));
  const tags = computed(() => getProductTags(product));
  const image = computed(() => getProductImage(product));
  const link = computed(() => getProductLink(product));
  return {
    description,
    tags,
    image,
    link
  };
}
export {
  useProductContent as default
};
